import { useMutation, useQueryClient } from "@tanstack/react-query";

import { useDomainServices } from "@/providers/DomainServices";

import { type DeviceTypeRecord } from "../DeviceTypeRecord";
import { type CreateDeviceTypeRequest } from "../DeviceTypeService";

import { deviceTypeQueryKeys } from "./deviceTypeQueryKeys";

interface CreateDeviceTypeParams {
  orgId: string;
  request: CreateDeviceTypeRequest;
}

export function useCreateDeviceType() {
  const { deviceTypes } = useDomainServices();
  const queryClient = useQueryClient();

  return useMutation<DeviceTypeRecord, Error, CreateDeviceTypeParams>({
    mutationFn: ({ orgId, request }) =>
      deviceTypes.createDeviceType(request, { orgId }),
    onSuccess: (created, { orgId }) => {
      void queryClient.invalidateQueries({
        queryKey: deviceTypeQueryKeys.list(orgId),
      });
      queryClient.setQueryData(
        deviceTypeQueryKeys.detail(created.device_type_id),
        created,
      );
    },
  });
}
